module.exports = __webpack_public_path__ + "static/media/adobe-reader-icon.505c1589.jpg";